export const SEARCH_WRAPPER_ID = 'heroSearchWrapper';
export const SEARCH_ICON = 'search';
export const HERO_RESULTS_ID = 'heroResults';
